__turbopack_context__.v({
  "alert": "search-controls-module-scss-module__hFRhyq__alert",
  "filters": "search-controls-module-scss-module__hFRhyq__filters",
  "filters--is-open": "search-controls-module-scss-module__hFRhyq__filters--is-open",
  "filters--mobile": "search-controls-module-scss-module__hFRhyq__filters--mobile",
  "filters-button-wrapper": "search-controls-module-scss-module__hFRhyq__filters-button-wrapper",
  "filters-wrapper": "search-controls-module-scss-module__hFRhyq__filters-wrapper",
  "loader": "search-controls-module-scss-module__hFRhyq__loader",
  "toolbar": "search-controls-module-scss-module__hFRhyq__toolbar",
  "toolbar__filter-button": "search-controls-module-scss-module__hFRhyq__toolbar__filter-button",
  "wrapper": "search-controls-module-scss-module__hFRhyq__wrapper",
  "wrapper--filters-open": "search-controls-module-scss-module__hFRhyq__wrapper--filters-open",
});
